import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { comissionsApi } from "services/Comissions";

const _reducers = combineReducers({
  [comissionsApi.reducerPath]: comissionsApi.reducer,
});

export const store = configureStore({
  reducer: _reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: true,
      serializableCheck: true,
    }).concat(comissionsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
